import { Link } from "react-router-dom"
import SimpleButton from "../../buttons/Simple-button"
import "./fixed-footer.css"
import SimpleOutlineButton from "../../buttons/Simple-Outline-button"

interface FixedFooterProps {
    onCancel?: () => any
    onSubmit: () => void
    onSubmitPostPayment?: () => void
    onSubmitSaveAddMorePayment?: () => void
    loading: boolean
    buttonLabel?: string
    SavePostPaymentbuttonLabel?: string
    ShowCancelButton?: Boolean;
    ShowSaveButton?: Boolean;
    ShowSavePostPaymentButton?: Boolean;
    ShowSaveAddMorePaymentButton?: Boolean;
    SaveAddMorebuttonLabel?: string
    ButtonGap?: number;
}



import { useMenu } from "../../../utils/context/MenuContext";

export default function FixedFooter({ ButtonGap = 8, onCancel, onSubmit, onSubmitPostPayment,onSubmitSaveAddMorePayment, loading, buttonLabel, ShowCancelButton = true, ShowSaveButton = true, ShowSavePostPaymentButton, SavePostPaymentbuttonLabel,ShowSaveAddMorePaymentButton,SaveAddMorebuttonLabel }: FixedFooterProps) {
    const { isOpen } = useMenu();
    
    return (
        <div className={`listing-footer-bottom ${isOpen ? "sidebar-open" : "sidebar-closed"} bg-white border-t border-gray-200 shadow-lg z-50`}>
            <div className="container-fluid px-4 py-3">
                <div className="d-flex flex-wrap justify-content-end gap-2 gap-md-2">

                    {ShowCancelButton &&
                        <button
                            type="button"
                            className={"popup-button popup-button-secondary"}
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    }

                    {ShowSavePostPaymentButton &&
                        <SimpleOutlineButton
                            onClick={onSubmitPostPayment}
                            label={SavePostPaymentbuttonLabel}
                            className="mx-1"
                            isDisabled={loading}
                        />
                    }

                    {ShowSaveAddMorePaymentButton &&
                        <SimpleOutlineButton
                            onClick={onSubmitSaveAddMorePayment}
                            label={SaveAddMorebuttonLabel}
                            className="mx-1"
                            isDisabled={loading}
                        />
                    }

                    {ShowSaveButton &&
                        <SimpleButton
                            onClick={onSubmit}
                            label={buttonLabel}
                            className="mx-1"
                            isDisabled={loading}
                        />
                    }
                </div>
            </div>
        </div>

    )
}
